module.exports = __webpack_public_path__ + "img/gallery_image-4.c0067ca.jpg";